@if (action == 'create') {
  <div class="container">
    <form [formGroup]="addVisitorForm" (ngSubmit)="onSubmit()">
      <mat-tab-group  mat-align-tabs="center" [selectedIndex]="selectedIndex" backgroundColor="primary" >
        <mat-tab label="Step 1 - Guest Details">
          <div class="row my-2">
            <div class="col-md-6">
              <div class="form-outline">
                <input type="text" id="firstName" formControlName="firstName" class="form-control" placeholder="e.g John" [ngClass]="{ 'is-invalid': submitAdd && fi.firstName.errors, 'is-valid': fi.firstName.valid && fi.firstName.touched }"/>
                <label class="form-label" for="firstName">First name</label>
                @if (submitAdd && fi.firstName.errors) {
                  <div class="invalid-feedback mb-2">
                    @if (fi.firstName.errors.required) {
                      <div>First name is required</div>
                    }
                  </div>
                }
                @if (fi.firstName && fi.firstName.errors?.pattern) {
                  <div class="invalid-feedback mb-2">
                    First name should have 2 or more letters
                  </div>
                }
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-outline">
                <input type="text" id="lastName" formControlName="lastName" class="form-control" placeholder="e.g Brown"  [ngClass]="{ 'is-invalid': submitAdd && fi.lastName.errors, 'is-valid': fi.lastName.valid && fi.lastName.touched }"/>
                <label class="form-label" for="lastName">Last name</label>
                @if (submitAdd && fi.lastName.errors) {
                  <div class="invalid-feedback mb-2">
                    @if (fi.lastName.errors.required) {
                      <div>Last name is required</div>
                    }
                  </div>
                }
                @if (fi.lastName && fi.lastName.errors?.pattern) {
                  <div class="invalid-feedback mb-2">
                    Last name should have 2 or more letters
                  </div>
                }
              </div>
            </div>
          </div>
          <label class="image-upload-container btn btn-bwm">
            <span>Select Image</span>
            <input #imageInput
              type="file"
              accept="image/*"
              (change)="processFile(imageInput)">
          </label>
          @if (selectedFile) {
            <div class="img-preview-container">
              <div class="img-preview{{selectedFile.status === 'fail' ? '-error' : ''}}"
                [ngStyle]="{'background-image': 'url('+ selectedFile.src + ')'}">
              </div>
              @if (selectedFile.pending) {
                <div class="img-loading-overlay">
                  <div class="img-spinning-circle"></div>
                </div>
              }
              @if (selectedFile.status === 'ok') {
                <div class="alert alert-success"> Image Uploaded Succesfuly!</div>
              }
              @if (selectedFile.status === 'fail') {
                <div class="alert alert-danger"> Image Upload Failed!</div>
              }
            </div>
          }
          <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
          <div class="file-upload">
            {{fileName || "No file uploaded yet."}}
            <button mat-mini-fab color="primary" class="upload-btn"
              (click)="fileUpload.click()">
              <mat-icon>attach_file</mat-icon>
            </button>
          </div>
          <!-- <div class="progress">
          <mat-progress-bar class="progress-bar" mode="determinate"
            [value]="uploadProgress" *ngIf="uploadProgress">
          </mat-progress-bar>
          <mat-icon class="cancel-upload" (click)="cancelUpload()"
          *ngIf="uploadProgress">delete_forever</mat-icon>
        </div> -->
        <div class="">
          <button type='button' (click)="next($event)" class="btn btn-primary mx-1 my-2 float-end">
            Continue &nbsp; <fa-icon [icon]="faCircleArrowRight"></fa-icon>
          </button>
        </div>
      </mat-tab>
      <mat-tab label="Step 2 - Access Details">
        <div class="controls">
          <button type='button' (click)="previous($event)" class="btn btn-warning float-start mx-1 my-2">
            Previous &nbsp; <fa-icon [icon]="faCircleArrowLeft"></fa-icon>
          </button>
          <button type='button' (click)="next($event)" class="btn btn-primary float-end mx-1 my-2">
            Continue &nbsp; <fa-icon [icon]="faCircleArrowRight"></fa-icon>
          </button>
        </div>
      </mat-tab>
      <mat-tab label="Step 3 - Review & Confirm">
        <div class="row d-inline-flex my-2">
          <div class="col-md-4">
            <div class="form-outline">
              <input type="text" id="firstName" formControlName="firstName" class="form-control" placeholder="e.g John" [ngClass]="{ 'is-invalid': submitAdd && fi.firstName.errors, 'is-valid': fi.firstName.valid && fi.firstName.touched }"/>
              <label class="form-label" for="firstName">First name</label>
              @if (submitAdd && fi.firstName.errors) {
                <div class="invalid-feedback mb-2">
                  @if (fi.firstName.errors.required) {
                    <div>First name is required</div>
                  }
                </div>
              }
              @if (fi.firstName && fi.firstName.errors?.pattern) {
                <div class="invalid-feedback mb-2">
                  First name should have 2 or more letters
                </div>
              }
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-outline">
              <input type="text" id="lastName" formControlName="lastName" class="form-control" placeholder="e.g Brown"  [ngClass]="{ 'is-invalid': submitAdd && fi.lastName.errors, 'is-valid': fi.lastName.valid && fi.lastName.touched }"/>
              <label class="form-label" for="lastName">Last name</label>
              @if (submitAdd && fi.lastName.errors) {
                <div class="invalid-feedback mb-2">
                  @if (fi.lastName.errors.required) {
                    <div>Last name is required</div>
                  }
                </div>
              }
              @if (fi.lastName && fi.lastName.errors?.pattern) {
                <div class="invalid-feedback mb-2">
                  Last name should have 2 or more letters
                </div>
              }
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-outline">
              <input type="text" id="lastName" formControlName="lastName" class="form-control" placeholder="e.g Brown"  [ngClass]="{ 'is-invalid': submitAdd && fi.lastName.errors, 'is-valid': fi.lastName.valid && fi.lastName.touched }"/>
              <label class="form-label" for="lastName">Phone #</label>
              @if (submitAdd && fi.lastName.errors) {
                <div class="invalid-feedback mb-2">
                  @if (fi.lastName.errors.required) {
                    <div>Last name is required</div>
                  }
                </div>
              }
              @if (fi.lastName && fi.lastName.errors?.pattern) {
                <div class="invalid-feedback mb-2">
                  Last name should have 2 or more letters
                </div>
              }
            </div>
          </div>
        </div>
        <div class="controls">
          <button type="button" (click)="previous($event)" class="btn btn-warning float-start mx-1 my-2">
            Previous &nbsp; <fa-icon [icon]="faCircleArrowLeft"></fa-icon>
          </button>
          <button class="btn btn-primary float-end mx-1 my-2">
            Confirm &nbsp; <fa-icon [icon]="faPaperPlane"></fa-icon>
          </button>
        </div>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>
}
@if (action == 'list' || action == undefined) {
  <div class="container mt-4">
    <p class="my-2 h3">Visitor Portal</p>
    <div class="row">
      <div class="form-group has-search col-md-8">
        <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
        <input type="text" name="search" [(ngModel)]="searchVisitor" class="form-control" placeholder="Search visitor by name, phone">
      </div>
      <div class="col-md-4">
        <button (click)="addVisitor()"  class="btn btn-success mb-2">Add Visitor <fa-icon [icon]="faPlusCircle"></fa-icon></button>
      </div>
    </div>
  </div>
}
@if (action == 'update') {
  <div class="container">
  </div>
}
